module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG2a0fb788776a372de3c8c890e2a77ed7.e1595d6c.png";